import { AccountStatus } from '@/types/generated/common/account'
import { TradeVenue } from '@/types/generated/common/types'

export interface AccountVenueIndex {
  activeAccountIds: ReadonlySet<string>
  accountVenueById: ReadonlyMap<string, TradeVenue>
}

/**
 * The account lookups `matchesTradingVenue` scopes a widget's open-order/position
 * indicators with. Deliberately ACTIVE (not isOrderEligibleAccount): these feed
 * display-only markers, and a read-only account's resting orders and positions are
 * still real and still shown — only order targets exclude read-only accounts.
 */
export function buildAccountVenueIndex(
  accounts: ReadonlyArray<{ accountId: string; status: AccountStatus; tradeVenue: TradeVenue }>
): AccountVenueIndex {
  const activeAccountIds = new Set<string>()
  const accountVenueById = new Map<string, TradeVenue>()
  for (const account of accounts) {
    accountVenueById.set(account.accountId, account.tradeVenue)
    if (account.status === AccountStatus.ACCOUNT_STATUS_ACTIVE) {
      activeAccountIds.add(account.accountId)
    }
  }
  return { activeAccountIds, accountVenueById }
}
